module.exports = __webpack_public_path__ + "static/media/HCMM738.36496fba.jpg";